// @file Landside store
import type { AppReview, SchoolLogo, TwitterReview } from '@@/bits/landside_helper'
import { HomePageCard, homepageCards } from '@@/bits/landside_helper'
import { defineStore } from 'pinia'
import { ref } from 'vue'

export const useLandsideStore = defineStore('landside', () => {
  const appReview = ref(homepageCards[HomePageCard.AppReview])
  const twitterReview = ref(homepageCards[HomePageCard.TwitterReview])
  const schoolLogos = ref(homepageCards[HomePageCard.Schools])

  // Actions

  function initializeState(data: {
    appReview: AppReview
    twitterReview: TwitterReview
    schoolLogos: SchoolLogo[]
  }): void {
    appReview.value = data.appReview ?? appReview.value
    twitterReview.value = data.twitterReview ?? twitterReview.value
    schoolLogos.value = data.schoolLogos ?? schoolLogos.value
  }

  return {
    // State
    appReview,
    twitterReview,
    schoolLogos,

    // Actions
    initializeState,
  }
})
